module.exports = __webpack_public_path__ + "img/sales_01.a2d53c4f.png";